/**
 * Switch data-src and data-srcset properties with src and srcset when element is in view.
 * Elements should have class 'lazy', and when loaded, will have class 'lazy-loaded'.
 * Should only be called after document load event.
 */

import isInView from './isinview';

// Just set classes on image load
function imageOnLoad() {
    this.classList.remove('lazy');
    this.classList.add('lazy-loaded');
}

// visibleCallback :: Element -> Boolean
function isVisibleCallback(element) {
    const src = element.dataset.src;
    const srcset = element.dataset.srcset;
    delete element.dataset.src;
    delete element.dataset.srcset;
    if (src) element.src = src;
    if (srcset) element.srcset = srcset;
    element.onload = imageOnLoad;
    return true;
}

// setup :: _ -> Boolean
function setup() {
    const elements = [].slice.call(document.querySelectorAll('.lazy'));
    if (!elements.length) return false;
    return isInView(elements, isVisibleCallback, null, 100);
}

// init :: _ -> Boolean
function init() {
    window.addEventListener('lazyrefresh', setup);
    return setup();
}

export default { init };
